// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".catalog-categories .swiper-container:not(.swiper-container-initialized) .swiper-wrapper{display:flex;gap:24px}.catalog-categories-wrapper{border-bottom:1px solid #e3e3e3}.catalog-categories-wrapper+.ps__rail-x{height:3px}.catalog-categories-wrapper+.ps__rail-x .ps__thumb-x{height:2px}.catalog-categories-wrapper+.ps__rail-x:hover{height:6px}.catalog-categories-wrapper+.ps__rail-x:hover .ps__thumb-x{height:4px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
